import cons from "../constants";
import axios from "axios";

export const recently = (net) => axios.get(cons.API(net).recently);

export const topRank = (pageNum, pageSize) =>
  axios.get(`${cons.API().topRank}?pageNum=${pageNum}&pageSize=${pageSize}`);

export const totalBalance = (net) => axios.get(cons.API(net).totalBalance);

export const miners = (net) => axios.get(cons.API().miners);

export const getLoca = (ip) => axios.get(cons.IP_ADDR(ip));

export const blocks = (pageNum) =>
  axios.get(`${cons.API().blocks}?pageNum=${pageNum}`);

export const blockDetail = (net, num) =>
  axios.get(`${cons.API().block}/${num}`);

export const lastBlock = () => axios.get(`${cons.API().lastBlock}`);

//export const blockDetailTxList = (net, num, page) => axios.get(cons.API(net).block+'/'+num+'/'+page);

export const blockDetailTxList = (net, num, type, page) =>
  axios.get(`${cons.API().block}/${num}/${type}/${page}`);

export const recentblocks = (net) => axios.get(cons.API().recentblocks);

export const blockpageinfo = (net) => axios.get(cons.API().blocks);

export const accountDetail = (net, address) =>
  axios.get(`${cons.API().account}/${address}`);

export const transactionPageInfo = (net) => axios.get(cons.API().transactions);

export const transactions = (net, page) =>
  axios.get(`${cons.API().transactions}/${page}`);

export const transactionList = (page) =>
  axios.get(`${cons.API().transactionList}/${page}`);

export const transactionDetail = (hash) =>
  axios.get(`${cons.API().transaction}/${hash}`);

export const transactionCntByAddress = (address) =>
  axios.get(`${cons.API().transactionByAddress}/${address}/count`);

export const transactionListByAddress = (address, pageNum, type = "") =>
  axios.get(
    `${
      cons.API().transactionByAddress
    }/${address}/${type}?pageNum=${pageNum}&pageSize=25`
  );

export const transactionListByBlock = (blockNumber) =>
  axios.get(`${cons.API().transactionByBlock}/${blockNumber}`);

export const transactionListByTokenType = (type, pageNum) =>
  axios.get(
    `${cons.API().transactionListByTokenType}?type=${type}&pageNum=${pageNum}`
  );

export const isContract = (address) =>
  axios.get(`${cons.API().isContract}/${address}`);

export const contractListsearch = (type, pageNum) =>
  axios.get(`${cons.API().contractList}?type=${type}&pageNum=${pageNum}`);

export const contractTransactionListsearch = (type, pageNum) =>
  axios.get(
    `${cons.API().transactionListByTokenType}?type=${type}&pageNum=${pageNum}`
  );

export const searchContract = (name) =>
  axios.get(`${cons.API().searchContract}/${name}`);

export const contractDetail = (address) =>
  axios.get(`${cons.API().contract}/${address}`);

export const contractInTransactions = (address, pageNum) =>
  axios.get(`${cons.API().contract}/${address}/transaction?pageNum=${pageNum}`);

export const contractInTransactions25 = (address, pageNum) =>
  axios.get(
    `${
      cons.API().contract
    }/${address}/transaction?pageNum=${pageNum}&pageSize=25`
  );

export const queryContract = (address, data) =>
  axios.post(`${cons.API().contract}/${address}/query`, data);

export const transferListByAccount = (address, pageNum) =>
  axios.get(
    `${cons.API().transfer}/account/${address}?pageNum=${pageNum}&pageSize=25`
  );

export const getTokenURI = (address, tokendID) =>
  axios.get(
    `${cons.API().getTokenURI}?contract=${address}&tokenID=${tokendID}`
  );
